// extracted by mini-css-extract-plugin
module.exports = {"description":"styles-module__description___QlXBP","showMore":"styles-module__showMore___2v7RB"};